import { FEATURE_FLAGS } from '@vizit/constants';
import { useFeatureFlag } from './use-feature-flag';

/**
 * Returns whether the Asset Details Export menu (creative brief PDF and image ZIP) should be shown.
 *
 * Defaults to `false`. The API reads the same `spark-asset-export` key and 404s the ZIP download while it is off.
 */
function useShowSparkAssetExport(): boolean {
  return useFeatureFlag(FEATURE_FLAGS.SPARK_ASSET_EXPORT, false);
}

export { useShowSparkAssetExport };
